import React from "react";
import logoLg from "../../assets/images/lg-logo.png";

const IconCalendar = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="3" y="5" width="18" height="16" rx="3" stroke="currentColor" strokeWidth="1.75" />
    <path d="M3 10h18" stroke="currentColor" strokeWidth="1.75" />
    <path d="M8 3v4M16 3v4" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
    <path d="M8 14h.01M12 14h.01M16 14h.01M8 17h.01M12 17h.01" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
  </svg>
);

const IconTeam = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="9" cy="8" r="3" stroke="currentColor" strokeWidth="1.75" />
    <circle cx="17" cy="9" r="2.5" stroke="currentColor" strokeWidth="1.75" />
    <path
      d="M3.5 19c.6-3 2.8-4.5 5.5-4.5S14 16 14.5 19"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
    />
    <path
      d="M14.5 14.8c1.7-.4 3.4.2 4.5 1.7.5.7.8 1.5.9 2.5"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
    />
  </svg>
);

const IconAutomate = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M13 2L4.5 13.5H12l-1 8.5L20.5 10H13L13 2z"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 * Left brand panel for Login / Signup — business-facing storytelling.
 */
const AuthBrandPanel = ({ mode = "login" }) => {
  const isSignup = mode === "signup";

  const features = [
    {
      icon: <IconCalendar />,
      title: "Calendar sync",
      text: "Google & Outlook stay in sync automatically.",
    },
    {
      icon: <IconTeam />,
      title: "Team booking",
      text: "Share availability and booking pages with clients.",
    },
    {
      icon: <IconAutomate />,
      title: "Automations",
      text: "Reminders, payments, and follow-ups on autopilot.",
    },
  ];

  return (
    <aside className="auth-brand">
      <div className="auth-brand__atmosphere" aria-hidden="true">
        <span className="auth-brand__orb auth-brand__orb--a" />
        <span className="auth-brand__orb auth-brand__orb--b" />
        <span className="auth-brand__grid" />
      </div>

      <div className="auth-brand__inner">
        <div className="auth-brand__top">
          <img className="auth-brand__logo" src={logoLg} alt="MeetOcto" />
          <span className="auth-brand__badge">
            {isSignup ? "Trusted by service businesses" : "Your workspace awaits"}
          </span>
        </div>

        <div className="auth-brand__copy">
          <p className="auth-brand__eyebrow">
            {isSignup ? "Scheduling for modern teams" : "Business scheduling platform"}
          </p>
          <h2 className="auth-brand__headline">
            {isSignup ? (
              <>
                Turn your calendar into a{" "}
                <span className="auth-brand__headline-accent">growth engine</span>
              </>
            ) : (
              <>
                Everything your team needs to{" "}
                <span className="auth-brand__headline-accent">book & deliver</span>
              </>
            )}
          </h2>
          <p className="auth-brand__sub">
            {isSignup
              ? "Launch a professional booking experience, connect calendars, and start converting inquiries into confirmed appointments."
              : "Pick up where you left off — events, availability, clients, and automations in one secure workspace."}
          </p>
        </div>

        <div className="auth-brand__features">
          {features.map((item) => (
            <div className="auth-brand__feature" key={item.title}>
              <div className="auth-brand__feature-icon">{item.icon}</div>
              <div className="auth-brand__feature-body">
                <strong>{item.title}</strong>
                <span>{item.text}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="auth-brand__trust">
          <div className="auth-brand__metric">
            <strong>24/7</strong>
            <span>Online booking</span>
          </div>
          <div className="auth-brand__metric-divider" />
          <div className="auth-brand__metric">
            <strong>Multi-calendar</strong>
            <span>Google · Outlook</span>
          </div>
          <div className="auth-brand__metric-divider" />
          <div className="auth-brand__metric">
            <strong>Team-ready</strong>
            <span>Staff & roles</span>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default AuthBrandPanel;
